import Building from './pages/Building/Building.vue';
import Parking from './pages/Parking/Parking.vue';
import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

/**
 * Oops
 * @see https://github.com/pillarjs/path-to-regexp/issues/106#issuecomment-302869563
 */

export default new Router({
    mode  : 'history',
    base  : process.env.BASE_URL,
    routes: [{
        path     : '/',
        name     : 'complex',
        component: Building
    }, {
        path     : '/building/:buildingId',
        name     : 'section',
        component: () => {
            return import('./pages/Section/Section.vue');
        }
    }, {
        path     : '/building/:buildingId/section/:sectionId',
        name     : 'floor',
        component: () => {
            return import('./pages/Floor/Floor.vue');
        }
    }, {
        path     : '/section/:sectionId',
        name     : 'floor',
        component: () => {
            return import('./pages/Floor/Floor.vue');
        }
    }, {
        path     : '/building/:building/section/:sectionId/floor/:floorId',
        name     : 'flat',
        component: () => {
            return import('./pages/Flat/Flat.vue');
        }
    }, {
        path     : '/section/:sectionId/floor/:floorId',
        name     : 'flat',
        component: () => {
            return import('./pages/Flat/Flat.vue');
        }
    }, {
        path     : '/parking',
        name     : 'parking',
        component: Parking
    }, {
        path     : '/parking/building/:buildingId/floor/:floorId',
        name     : 'parking',
        component: Parking
    }]
});
